import createIcon from '../../createIcon';

/**
 * @component @name BrightnessMedium
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMDY3OCkiPgo8cGF0aCBkPSJNMTkuOTk5OSAxNS4zMTA0TDIzLjMwOTkgMTIuMDAwNEwxOS45OTk5IDguNjkwNDNWNC4wMDA0M0gxNS4zMDk5TDExLjk5OTkgMC42OTA0M0w4LjY4OTk0IDQuMDAwNDNIMy45OTk5NFY4LjY5MDQzTDAuNjg5OTQxIDEyLjAwMDRMMy45OTk5NCAxNS4zMTA0VjIwLjAwMDRIOC42ODk5NEwxMS45OTk5IDIzLjMxMDRMMTUuMzA5OSAyMC4wMDA0SDE5Ljk5OTlWMTUuMzEwNFpNMTEuOTk5OSAxOC4wMDA0VjYuMDAwNDNDMTUuMzA5OSA2LjAwMDQzIDE3Ljk5OTkgOC42OTA0MyAxNy45OTk5IDEyLjAwMDRDMTcuOTk5OSAxNS4zMTA0IDE1LjMwOTkgMTguMDAwNCAxMS45OTk5IDE4LjAwMDRaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI0MDJfMjA2NzgiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrightnessMedium = createIcon('BrightnessMedium', [
  ['g', { clipPath: 'url(#clip0_2402_20678)', key: 'msrqb6' }],
  ['defs', { key: '9ahrjx' }],
]);

export default BrightnessMedium;
